"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeferLiquidityCheckAdapterV4Factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "tectonicSocketAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "erc20Addresses",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "tTokenAddresses",
                type: "address[]",
            },
        ],
        name: "SetErc20TokenToTTokenMapping",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "tectonicSocketAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "oracleAddress",
                type: "address",
            },
        ],
        name: "SetOracle",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "tectonicSocketAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "erc20Addresses",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "tTokenAddresses",
                type: "address[]",
            },
        ],
        name: "SetTTokenToErc20TokenMapping",
        type: "event",
    },
    {
        inputs: [],
        name: "WETH",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "adapterVersion",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "allowedDex",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_ferroSwap",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "erc20",
                type: "address[]",
            },
        ],
        name: "approveFerroSwap",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "erc20",
                type: "address[]",
            },
            {
                internalType: "address[]",
                name: "tToken",
                type: "address[]",
            },
        ],
        name: "approveToTToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "erc20TokenToTTokenMap",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tectonicSocketAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                internalType: "address",
                name: "repayTToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "seizeTToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "repayAmount",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "dexes",
                type: "address[]",
            },
            {
                internalType: "address[][]",
                name: "paths",
                type: "address[][]",
            },
        ],
        name: "flashLoanAndLiquidate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "flashLoanAndLiquidateCallback",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "flashLoanAndLiquidateSlippageTolerance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tectonicSocketAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "repayAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "slippageTolerance",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "path",
                type: "address[]",
            },
        ],
        name: "getTTokenAmountIn",
        outputs: [
            {
                internalType: "uint256",
                name: "tTokenAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountInMax",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tectonicSocketAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "fromAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "slippageTolerance",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "path",
                type: "address[]",
            },
        ],
        name: "getTTokenAmountOut",
        outputs: [
            {
                internalType: "uint256",
                name: "tTokenAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountOutMin",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_WETH",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lavaBarLimit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "oracles",
        outputs: [
            {
                internalType: "contract IPriceOracle",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tectonicSocketAddress",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "erc20",
                type: "address[]",
            },
            {
                internalType: "address[]",
                name: "tToken",
                type: "address[]",
            },
        ],
        name: "setErc20TokenToTTokenMap",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tectonicSocketAddress",
                type: "address",
            },
            {
                internalType: "contract IPriceOracle",
                name: "oracle",
                type: "address",
            },
        ],
        name: "setOracle",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tectonicSocketAddress",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "erc20",
                type: "address[]",
            },
            {
                internalType: "address[]",
                name: "tToken",
                type: "address[]",
            },
        ],
        name: "setTTokenToErc20TokenMap",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IVVSRouter02",
                name: "_vvs",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "erc20",
                type: "address[]",
            },
        ],
        name: "setVVSAndApprove",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tectonicSocketAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tTokenAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountOutMin",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "path",
                type: "address[]",
            },
        ],
        name: "swapAndDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "swapAndDepositCallback",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tectonicSocketAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tTokenAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "repayAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountInMax",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "path",
                type: "address[]",
            },
        ],
        name: "swapAndRepay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "swapAndRepayCallback",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tTokenToErc20TokenMap",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "vvs",
        outputs: [
            {
                internalType: "contract IVVSRouter02",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "wowmaxRouter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
class DeferLiquidityCheckAdapterV4Factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.DeferLiquidityCheckAdapterV4Factory = DeferLiquidityCheckAdapterV4Factory;
DeferLiquidityCheckAdapterV4Factory.bytecode = _bytecode;
DeferLiquidityCheckAdapterV4Factory.abi = _abi;
//# sourceMappingURL=DeferLiquidityCheckAdapterV4Factory.js.map